import { createSlice } from "@reduxjs/toolkit";

const profileSlice = createSlice({
  name: "profile",
  initialState: {   
    saveUserProfileProgress: false,
    activeStep: 0,
    skillGoals: [],
    jobGoals: [],
  },
  reducers: {
    resetState(state, action) {
      state.saveUserProfileProgress = false;
    },
    setState(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    setJobGoals(state, action) { 
      state.jobGoals = action.payload;
    },
    setSkillGoals(state, action) { 
      state.skillGoals = action.payload;
    }
  },
});

export const profileActions = profileSlice.actions;

export default profileSlice.reducer;